import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EDealType } from '../../types/dealType';
import { IPreciseFiltersData, TPreciseFiltersState } from '../../types/redux/preciseFilters';

export enum EActionTypes {
  Request = 'preciseFilters/Request',
  Success = 'preciseFilters/Success',
  Failure = 'preciseFilters/Failure',
  SetState = 'preciseFilters/SetState',
}

export interface IGetFiltersSuccessPayload {
  dealType: EDealType;
  data: IPreciseFiltersData | null;
}

export const getFiltersRequest = actionGenerator<EActionTypes.Request>(EActionTypes.Request);
export const getFiltersSuccess = actionGenerator<EActionTypes.Success, IGetFiltersSuccessPayload>(EActionTypes.Success);
export const getFiltersFailure = actionGenerator<EActionTypes.Failure>(EActionTypes.Failure);
export const setPreciseFiltersState = actionGenerator<EActionTypes.SetState, TPreciseFiltersState>(
  EActionTypes.SetState,
);

export type TGetFiltersRequest = ReturnType<typeof getFiltersRequest>;
export type TGetFiltersSuccess = ReturnType<typeof getFiltersSuccess>;
export type TGetFiltersFailure = ReturnType<typeof getFiltersFailure>;
export type TSetFiltersUi = ReturnType<typeof setPreciseFiltersState>;

export type TPreciseFiltersActions = TGetFiltersRequest | TGetFiltersSuccess | TGetFiltersFailure | TSetFiltersUi;
